import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

export enum BfxLadderBlotterColumnSelectorEventType {
  SELECTOR_SHOW,
  SELECTOR_HIDE,
}

export class BfxLadderBlotterColumnSelectorEvent {
  constructor(
    public eventType: BfxLadderBlotterColumnSelectorEventType,
    public ladderBlotter: any,
    public gridOptions?: any,
    public x?: number,
    public y?: number,
  ) {}
}

export class BfxBlotterActionEvent {
  constructor(public ladderBlotter: any, public columnDef: Array<any>) {}
}

/**
 * Override to implements specifics for specific blotter
 */

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { NativeDesktopSupport } from "../bfx-native-desktop/native-desktop-support";

@Injectable()
export class BfxBaseBlotterColumnSelectorService {
  public showSelectorSubject: Subject<BfxLadderBlotterColumnSelectorEvent> =
    new Subject<BfxLadderBlotterColumnSelectorEvent>();
  constructor() {}

  public showColumnSelector(ladderBlotter: any, gridOptions: any): void {
    this.showSelectorSubject.next(
      new BfxLadderBlotterColumnSelectorEvent(
        BfxLadderBlotterColumnSelectorEventType.SELECTOR_SHOW,
        ladderBlotter,
        gridOptions,
      ),
    );
  }

  public hideColumnSelector(ladderBlotter: any): void {
    this.showSelectorSubject.next(
      new BfxLadderBlotterColumnSelectorEvent(
        BfxLadderBlotterColumnSelectorEventType.SELECTOR_HIDE,
        ladderBlotter,
      ),
    );
  }

  public doColumnSelectorMenu(blotter: any, gridOptions: any, event: any): void {
    if (NativeDesktopSupport.isNativeDesktopContainer()) {
      this.showSelectorSubject.next(
        new BfxLadderBlotterColumnSelectorEvent(
          BfxLadderBlotterColumnSelectorEventType.SELECTOR_SHOW,
          blotter,
          gridOptions,
          event.screenX,
          event.screenY,
        ),
      );
    } else {
      this.showSelectorSubject.next(
        new BfxLadderBlotterColumnSelectorEvent(
          BfxLadderBlotterColumnSelectorEventType.SELECTOR_SHOW,
          blotter,
          gridOptions,
          event.clientX,
          event.clientY,
        ),
      );
    }
  }
}
